module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Moon-973ea6be9a0c467410dbefd3ed8df2ba.svg";